var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12V3",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7902 7.5L4.20898 16.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.15009 13.65C3.04777 13.106 2.99755 12.5535 3.00009 12C2.99891 10.1387 3.57545 8.32287 4.65016 6.80317C5.72487 5.28346 7.24476 4.13477 9.00009 3.51562V10.2656L3.15009 13.65Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 3C13.5768 3.00018 15.1261 3.41474 16.4925 4.20215C17.8589 4.98957 18.9944 6.12219 19.7852 7.48658C20.5761 8.85096 20.9946 10.3992 20.9987 11.9762C21.0029 13.5533 20.5926 15.1037 19.809 16.4722C19.0253 17.8408 17.8958 18.9794 16.5336 19.774C15.1714 20.5686 13.6243 20.9914 12.0473 20.9999C10.4703 21.0084 8.91878 20.6024 7.54809 19.8225C6.17739 19.0426 5.03567 17.9163 4.2373 16.5563",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.2467fa4417c4a5a2761bb595fd4c8f76.svg";
export { ForwardRef as ReactComponent };